import { every } from 'lodash';
import { ReactElement, ReactNode, useMemo } from 'react';

import useSession from 'api/session';
import allPermissions from 'common/permissions';

interface PermissionGateProps {
  permissions?: Array<keyof typeof allPermissions>;
  children: ReactNode;
}
const PermissionGate = ({
  permissions = [],
  children,
}: PermissionGateProps): ReactElement | null => {
  const { data: session } = useSession();
  const hasPermission = useMemo(
    () =>
      every(
        permissions,
        (permission) =>
          permission && session?.permissions.includes(permission?.toString())
      ),
    [permissions, session]
  );

  if (!hasPermission) return null;

  return <>{children}</>;
};

export default PermissionGate;
